// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/32413
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 32413 
import { eventTrackingUtils } from '@/utils/eventTrack/eventTrackingUtils'
interface IExpoTrackParamsRecord {
  /** 平台心智曝光 */
Home_Platform_Mind_Expo: {
/** 标题  */
title: Array<string>,
/** 按钮样式 1-纵向,2-横向 */
styleType: |1|2,
/** 小首页名称  */
Mini_Hp_Name: string}
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord,string>> = Object.freeze({
/** 平台心智曝光 */
  Home_Platform_Mind_Expo:'Home_Platform_Mind_Expo',
})

interface IClickTrackParamsRecord {
  /** 平台心智点击 */
Home_Platform_Mind: {
/** 标题  */
title: Array<string>,
/** 按钮样式 1-纵向,2-横向 */
styleType: |1|2,
/** 小首页名称  */
Mini_Hp_Name: string}
}

const sendClickTrack = {
  /** 点击事件上报-平台心智点击 */
Home_Platform_Mind: (json_param: IClickTrackParamsRecord['Home_Platform_Mind']) => {
    eventTrackingUtils.submitCL({event_id:'Home_Platform_Mind',json_param});
  },
}

export {
  EXPOSURE_RECORD,
  sendClickTrack,
}
export type {
  IExpoTrackParamsRecord,
}